<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">
            {{ $t(titulo || "Detalhes do Acolhimento") }}
        </h1>
        <load v-if="loading" :mode="mode" />
        <div v-else id="boxPrint" class="row">

            <div class="col-md-12">
                <print-header />
                <table class="table table-bordered bg-white table-sm">
                    <tbody>
                        <tr>
                            <td>
                                ID:<b>{{ item.id }}</b> Protocolo:<b>{{
                                    item.protocolo
                                }}</b>
                            </td>
                            <td>
                                Criado:<b>{{ item.cadastrado }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Técnico Responsável:<b v-if="item.responsavel">{{ item.responsavel.name }}</b>
                            </td>
                            <td>
                                Atualizado:<b>{{ item.atualizado }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                Unidade:<b v-if="item.unidade">{{
                                    item.unidade.nome
                                }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <template v-if="isIdoso">

                    <h5 class="font-weight-bold text-center">Identificação da Pessoa</h5>

                    <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
                        <tbody>
                            <tr>
                                <td>
                                    Nome:
                                    <b>{{ item.nome_acolhido }} </b>
                                </td>
                                <td>
                                    Idade:
                                    <b>{{ calcularIdade(item.nascimento) }}</b>
                                </td>
                                <td>
                                    CPF:
                                    <strong>{{ item.cpf | VMask("###.###.##-##") }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Data de Nascimento:
                                    <strong v-if="item.nascimento">
                                        {{formatDate(item.nascimento)}}
                                    </strong>
                                </td>
                                <td colspan="2">
                                    Naturalidade:
                                    <strong>
                                        {{ item.naturalidade }}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Situação Conjugal:
                                    <strong>{{ getValue( item.estado_civil, $root.arrays.estado_civil) }}</strong>
                                </td>
                                <td colspan="2">
                                    Telefone:
                                    <strong> {{ item.telefone_contato }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    Endereço:
                                    <strong> {{ item.local_origem }} </strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="item.metaIdoso && item.metaIdoso.idoso">

                        <h4 class="font-weight-bold text-center">Objetivos e Metas </h4>

                        <!-- Documental -->
                        <div>
                            <h5 class="font-weight-bold text-center">Situação Documental</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.documental_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.documental_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.documental_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Processual -->
                        <div>
                            <h5 class="font-weight-bold text-center">Situação Processual</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.processual_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.processual_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.processual_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Saúde -->
                        <div>
                            <h5 class="font-weight-bold text-center">Saúde</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.saude_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.saude_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.saude_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Educação -->
                        <div>
                            <h5 class="font-weight-bold text-center">Educação</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.educacao_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.educacao_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.educacao_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Profissionalização -->
                        <div>
                            <h5 class="font-weight-bold text-center">Profissionalização</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.profissionalizacao_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.profissionalizacao_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.profissionalizacao_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Arte, Cultura, Esporte E Lazer -->
                        <div>
                            <h5 class="font-weight-bold text-center">Arte, Cultura, Esporte E Lazer</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.arte_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.arte_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.arte_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Aspectos Sociofamiliares -->
                        <div>
                            <h5 class="font-weight-bold text-center">Aspectos Sociofamiliares</h5>
                            <table class="table table-sm table-bordered bg-white mb-3">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.aspecto_prazo) }}</td></tr>
                                <tr>
                                <td>Possui rede de apoio (pessoas/grupos que prestam algum tipo de suporte)?</td>
                                <td>{{ getValue(item.metaIdoso.idoso.possui_rede_apoio, $root.arrays.pergunta) }}</td>
                                </tr>
                                <tr>
                                <td>Intervenção e Percepção do Profissional referente aos aspectos sociofamiliares</td>
                                <td>{{ item.metaIdoso.idoso.intervencoes_sociofamiliares }}</td>
                                </tr>
                                <tr>
                                <td>Percepção da equipe SUAS</td>
                                <td v-html="item.metaIdoso.idoso.text_equipe_suas"></td>
                                </tr>
                                <tr>
                                <td>Situação Atual</td>
                                <td v-html="item.metaIdoso.idoso.aspecto_situacao_atual"></td>
                                </tr>
                                <tr>
                                <td>Objetivo/Meta</td>
                                <td v-html="item.metaIdoso.idoso.aspecto_meta"></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Condições Socioeconômicas -->
                        <div>
                            <h5 class="font-weight-bold text-center">Condições Socioeconômicas</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.condicao_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.condicao_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.condicao_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Vulnerabilidade e Riscos -->
                        <div>
                            <h5 class="font-weight-bold text-center">Vulnerabilidade e Riscos</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.vulnerabildiade_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.vulnerabildiade_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.vulnerabildiade_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Autonomia / autoestima / identidade -->
                        <div>
                            <h5 class="font-weight-bold text-center">Autonomia / autoestima / identidade</h5>
                            <table class="table table-sm table-bordered bg-white">
                            <tbody>
                                <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.autonomia_prazo) }}</td></tr>
                                <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.autonomia_situacao_atual"></td></tr>
                                <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.autonomia_meta"></td></tr>
                            </tbody>
                            </table>
                        </div>

                        <!-- Preparação para desligamento -->
                        <div>
                            <h5 class="font-weight-bold text-center">Preparação para desligamento</h5>
                            <table class="table table-sm table-bordered bg-white">
                                <tbody>
                                    <tr><td>Prazo</td><td>{{ formatDate(item.metaIdoso.idoso.desligamento_prazo) }}</td></tr>
                                    <tr><td>Situação Atual</td><td v-html="item.metaIdoso.idoso.desligamento_situacao_atual"></td></tr>
                                    <tr><td>Objetivo/Meta</td><td v-html="item.metaIdoso.idoso.desligamento_meta"></td></tr>
                                    <tr><td>Data do Desligamento</td><td>{{ formatDate(item.metaIdoso.idoso.data_desligamento) }}</td></tr>
                                    <tr>
                                        <td>Motivo do Desligamento</td>
                                        <td>{{ getValue(item.metaIdoso.idoso.motivo_desligamento, $root.arrays.motivo_desligamento_acolhimento) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Dados da rede socioassistencial e intersetorial para acompanhamento: local(s), serviço(s), programa(s)</td>
                                        <td v-html="item.metaIdoso.idoso.dados_da_rede_socioassistencial"></td>
                                    </tr>
                                    <tr>
                                        <td>Ações pactuadas no período pós-acolhimento e prazo(s)</td>
                                        <td v-html="item.metaIdoso.idoso.acao_repactuada"></td>
                                    </tr>
                                    <tr>
                                        <td>Rede de apoio para contato</td>
                                        <td v-html="item.metaIdoso.idoso.rede_apoio_contato"></td>
                                    </tr>
                                    <tr>
                                        <td>Observações</td>
                                        <td v-html="item.metaIdoso.idoso.observacoes_desligamento"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>

                <template v-else>

                    <div class="row">
                        <div class="col-12">
                            <template v-if="todasPessoas.length > 1">
                                <h3>Pessoas Vinculadas ao Acolhimento:</h3>

                                <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                                    <template #cell(nome)="row">
                                        <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                        {{ row.item.nome }}
                                        </a>
                                    </template>
                                </b-table>
                            </template>

                            <div
                                v-if="pessoaSelecionada"
                                :class="{ 'mt-4': todasPessoas.length > 1 }"
                            >

                                <div v-if="pessoaSelecionada && pessoaSelecionada.tipo_cadastro === 'Principal'">

                                    <!-- Isso aqui só será exibido se for o acolhido principal -->

                                    <h5 class="font-weight-bold text-center">Identificação da Pessoa</h5>

                                    <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    Nome:
                                                    <b>{{ item.nome_acolhido }} </b>
                                                </td>
                                                <td>
                                                    Idade:
                                                    <b>{{ calcularIdade(item.nascimento) }}</b>
                                                </td>
                                                <td>
                                                    CPF:
                                                    <strong>{{ item.cpf | VMask("###.###.##-##") }}</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Data de Nascimento:
                                                    <strong v-if="item.nascimento">
                                                        {{formatDate(item.nascimento)}}
                                                    </strong>
                                                </td>
                                                <td colspan="2">
                                                    Naturalidade:
                                                    <strong>
                                                        {{ item.naturalidade }}
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Situação Conjugal:
                                                    <strong>{{ getValue( item.estado_civil, $root.arrays.estado_civil) }}</strong>
                                                </td>
                                                <td colspan="2">
                                                    Telefone:
                                                    <strong> {{ item.telefone_contato }}</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    Endereço:
                                                    <strong> {{ item.local_origem }} </strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div v-else>

                                    <h5 class="font-weight-bold text-center">Identificação da Pessoa</h5>

                                    <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    Nome:
                                                    <b>{{ pessoaSelecionada.nome }} </b>
                                                </td>
                                                <td>
                                                    Idade:
                                                    <b>{{ calcularIdade(pessoaSelecionada.data_nascimento) }}</b>
                                                </td>
                                                <td>
                                                    CPF:
                                                    <strong>{{ pessoaSelecionada.cpf | VMask("###.###.##-##") }}</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Data de Nascimento:
                                                    <strong v-if="pessoaSelecionada.data_nascimento">
                                                        {{formatDate(pessoaSelecionada.data_nascimento)}}
                                                    </strong>
                                                </td>
                                                <td colspan="2">
                                                    Parentesco:
                                                    <strong>
                                                        {{ pessoaSelecionada.parentesco }}
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    E-mail:
                                                    <strong> {{ pessoaSelecionada.email }}</strong>
                                                </td>
                                                <td>
                                                    Telefone:
                                                    <strong> {{ pessoaSelecionada.telefone }}</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    Endereço:
                                                    <strong> {{ pessoaSelecionada.endereco }} </strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div v-if="dadosCompletosPessoaSelecionada().metaIdoso">

                                    <h4 class="font-weight-bold text-center">Objetivos e Metas </h4>

                                    <!-- Documental -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Situação Documental</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.documental_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.documental_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.documental_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Processual -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Situação Processual</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.processual_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.processual_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.processual_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Saúde -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Saúde</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.saude_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.saude_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.saude_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Educação -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Educação</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.educacao_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.educacao_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.educacao_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Profissionalização -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Profissionalização</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.profissionalizacao_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.profissionalizacao_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.profissionalizacao_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Arte, Cultura, Esporte E Lazer -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Arte, Cultura, Esporte E Lazer</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.arte_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.arte_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.arte_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Aspectos Sociofamiliares -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Aspectos Sociofamiliares</h5>
                                        <table class="table table-sm table-bordered bg-white mb-3">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.aspecto_prazo) }}</td></tr>
                                            <tr>
                                            <td>Possui rede de apoio (pessoas/grupos que prestam algum tipo de suporte)?</td>
                                            <td>{{ getValue(dadosCompletosPessoaSelecionada().metaIdoso.possui_rede_apoio, $root.arrays.pergunta) }}</td>
                                            </tr>
                                            <tr>
                                            <td>Intervenção e Percepção do Profissional referente aos aspectos sociofamiliares</td>
                                            <td>{{ dadosCompletosPessoaSelecionada().metaIdoso.intervencoes_sociofamiliares }}</td>
                                            </tr>
                                            <tr>
                                            <td>Percepção da equipe SUAS</td>
                                            <td v-html="dadosCompletosPessoaSelecionada().metaIdoso.text_equipe_suas"></td>
                                            </tr>
                                            <tr>
                                            <td>Situação Atual</td>
                                            <td v-html="dadosCompletosPessoaSelecionada().metaIdoso.aspecto_situacao_atual"></td>
                                            </tr>
                                            <tr>
                                            <td>Objetivo/Meta</td>
                                            <td v-html="dadosCompletosPessoaSelecionada().metaIdoso.aspecto_meta"></td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Condições Socioeconômicas -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Condições Socioeconômicas</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.condicao_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.condicao_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.condicao_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Vulnerabilidade e Riscos -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Vulnerabilidade e Riscos</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.vulnerabildiade_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.vulnerabildiade_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.vulnerabildiade_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Autonomia / autoestima / identidade -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Autonomia / autoestima / identidade</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                        <tbody>
                                            <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.autonomia_prazo) }}</td></tr>
                                            <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.autonomia_situacao_atual"></td></tr>
                                            <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.autonomia_meta"></td></tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <!-- Preparação para desligamento -->
                                    <div>
                                        <h5 class="font-weight-bold text-center">Preparação para desligamento</h5>
                                        <table class="table table-sm table-bordered bg-white">
                                            <tbody>
                                                <tr><td>Prazo</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.desligamento_prazo) }}</td></tr>
                                                <tr><td>Situação Atual</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.desligamento_situacao_atual"></td></tr>
                                                <tr><td>Objetivo/Meta</td><td v-html="dadosCompletosPessoaSelecionada().metaIdoso.desligamento_meta"></td></tr>
                                                <tr><td>Data do Desligamento</td><td>{{ formatDate(dadosCompletosPessoaSelecionada().metaIdoso.data_desligamento) }}</td></tr>
                                                <tr>
                                                    <td>Motivo do Desligamento</td>
                                                    <td>{{ getValue(dadosCompletosPessoaSelecionada().metaIdoso.motivo_desligamento, $root.arrays.motivo_desligamento_acolhimento) }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Dados da rede socioassistencial e intersetorial para acompanhamento: local(s), serviço(s), programa(s)</td>
                                                    <td v-html="dadosCompletosPessoaSelecionada().metaIdoso.dados_da_rede_socioassistencial"></td>
                                                </tr>
                                                <tr>
                                                    <td>Ações pactuadas no período pós-acolhimento e prazo(s)</td>
                                                    <td v-html="dadosCompletosPessoaSelecionada().metaIdoso.acao_repactuada"></td>
                                                </tr>
                                                <tr>
                                                    <td>Rede de apoio para contato</td>
                                                    <td v-html="dadosCompletosPessoaSelecionada().metaIdoso.rede_apoio_contato"></td>
                                                </tr>
                                                <tr>
                                                    <td>Observações</td>
                                                    <td v-html="dadosCompletosPessoaSelecionada().metaIdoso.observacoes_desligamento"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </template>

                <print-footer 
                    v-if=" item.responsavel.tecnico.assinatura_digital" 
                    :tecnico="item.responsavel.tecnico" 
                    class="mt-0" 
                    :assinatura=" item.responsavel.tecnico.assinatura_digital"
                    :wpp="wpp"
                    :email="email"
                />
              
                <div class="row pt-4 px-0 d-flex justify-content-end no-print">
                    <div class="col-auto px-2 text-right">
                        <router-link v-if="mode != 'table'" :to="`/dashboard/acolhimentos/idoso/${item.unidade_id}`"
                            class="btn btn-default">
                            <i class="mdi mdi-arrow-left" />
                        </router-link>

                        <a class="btn btn-sm py-1 btn-primary" @click="print()">
                            <i class="mdi mdi-printer mdi-18px" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: ["titulo", "mode"],
    name: "Show",
    data() {
        return {
            pessoaSelecionada: null,
            loading: true,
            item: {},
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
            tipos: [],
            tecnicos: [],
            unidades: [],
            servicos: [],
            pessoaReferencia: [],
        };
    },
    mounted() {
        this.getServicos();
        this.getItem();
    },
    computed: {
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
        todasPessoas() {
            if (!this.item || !this.pessoaReferencia) return [];

            const pessoaPrincipal = {
                id: 'principal',
                nome: this.item.nome_acolhido,
                idade: this.calcularIdade(this.item.nascimento),
                parentesco: 'Acolhido(a)',
                tipo_cadastro: 'Principal',
            };

            const vinculados = this.pessoaReferencia.filter(
                p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
            );

            return [pessoaPrincipal, ...vinculados];
        },
    },
    methods: {
        selecionarPessoa(pessoa) {
            this.pessoaSelecionada = pessoa;
        },
        getDadosModuloPorPessoa(modulo, pessoa) {
            if (!this.item || !this.item[modulo]) return null;

            const dadosModulo = this.item[modulo];

            if (pessoa.tipo_cadastro === 'Principal') {
                return dadosModulo.idoso || null;
            }

            // Para vinculados
            if (Array.isArray(dadosModulo.pessoasVinculadas)) {
                return dadosModulo.pessoasVinculadas.find(d => String(d.pessoa_referencia_id) === String(pessoa.id)) || null;
            }

            return null;
        },
        dadosCompletosPessoaSelecionada() {
            if (!this.pessoaSelecionada) return null;

            const modulos = [
                'metaIdoso',
                'educacao',
                'remuneracaoAuxilio',
                'aspectoGeral',
                'caractSaude',
                'primeiraObservacao'
            ];

            const resultado = {};

            modulos.forEach(modulo => {
                resultado[modulo] = this.getDadosModuloPorPessoa(modulo, this.pessoaSelecionada);
            });

            return resultado;
        },
        getArrayValue(arrayKey, id) {
            const lista = this.$root.arrays[arrayKey] || [];
            const item = lista.find(el => el.id == id);
            return item ? item.value : '-';
        },
        mostrarDeficiencia() {
            return this.item.deficiencia == 1;
        },
        mostrarMotivoOutro() {
            return this.item.motivo_acolhimento?.some(id => id === 19);
        },
        booleanText(val) {
            return val == 1 ? 'Sim' : 'Não';
        },
        servicoSelecionado(id) {
            return this.servicos.find(s => s.id == id) || {};
        },
        getServicos() {
            return axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
                this.servicos = response.data;
            });
        },
        formatDate(dateStr) {
            if (!dateStr || dateStr === '0000-00-00') return '-';
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return '-';
            return date.toLocaleDateString('pt-BR');
        },
        calcularIdade(dataNascimento) {
            if (!dataNascimento) return '-';
            const hoje = new Date();
            const nascimento = new Date(dataNascimento);
            let idade = hoje.getFullYear() - nascimento.getFullYear();
            const mes = hoje.getMonth() - nascimento.getMonth();

            if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
                idade--;
            }

            return idade + ' ano(s)';
        },
        getPrazo(data) {
            if (data) {
                const data_final = moment(data);
                const data_atual = moment();
                const prazo = data_final.diff(data_atual, "months");
                return prazo + " mes(es)";
            }
            return '-';
        },
        getItem() {
            this.loading = true;
            this.pessoaSelecionada = null;
            axios.get(`api/dashboard/acolhimento/idoso/${this.$route.params.id}`).then((response) => {
                this.item = response.data.data;

                this.pessoaReferencia = this.item.pessoaReferencia || [];

                try {
                    if (typeof this.item.motivo_acolhimento === 'string') {
                        this.item.motivo_acolhimento = JSON.parse(this.item.motivo_acolhimento);
                    }
                } catch (e) {
                    this.item.motivo_acolhimento = [];
                }

                if (!this.isIdoso && this.todasPessoas.length === 1) {
                    this.selecionarPessoa(this.todasPessoas[0]);
                }
            }).finally(() => {
                this.loading = false;
            }).catch((error) => {
                this.$router.push(`/dashboard/acolhimento/unidades`);
            });
        },
        getValue(value, array) {
            if (value) {
                const result = array.filter((item) => item.id == value);
                return result[0] ? result[0].value : "";
            } else {
                return "";
            }
        },
        print() {
            const modal = document.getElementById("boxPrint");
            const cloned = modal.cloneNode(true);
            let section = document.getElementById("print");

            if (!section) {
                section = document.createElement("div");
                section.id = "print";
                document.body.appendChild(section);
            }

            section.innerHTML = "";
            section.appendChild(cloned);
            window.print();
        },
    },
};
</script>

<style>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>

<style>
    @media screen {
        #print {
            display: none;
        }
    }

    @media print {
        body * {
            visibility: hidden;
        }

        #print,
        #print * {
            visibility: visible;
        }

        #print {
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
</style>
